import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorAlertMessage } from '../ErrorAlertMessage';
import { useEnrichableObjectTypes } from '../EnrichableObjectTypesProvider';
import { useAlerts } from 'breeze-intelligence-kit';
import { getObjectTypeLabel, isContactObjectType } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const usePanelAlerts = ({
  objectTypeId
}) => {
  const {
    addAlertDanger,
    addAlertSuccess
  } = useAlerts();
  const {
    companyLabel,
    companyLabelLowercase,
    companyLabelPluralLowercase,
    contactLabel,
    contactLabelLowercase,
    contactLabelPluralLowercase
  } = useEnrichableObjectTypes();
  const objectTypeLabel = isContactObjectType(objectTypeId) ? contactLabelLowercase : companyLabelLowercase;
  const objectTypeLabelCapitalized = isContactObjectType(objectTypeId) ? contactLabel : companyLabel;
  const onError = errorId => {
    addAlertDanger({
      message: /*#__PURE__*/_jsx(ErrorAlertMessage, {
        errorId: errorId,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.panel.alerts.error.description"
        })
      }),
      titleText: I18n.text('enrichmentProperties.panel.alerts.error.title', {
        objectType: objectTypeLabel
      })
    });
  };
  const onErrorPropertiesAccess = errorId => {
    addAlertDanger({
      message: /*#__PURE__*/_jsx(ErrorAlertMessage, {
        errorId: errorId,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.panel.alerts.propertiesAccessError.description"
        })
      }),
      titleText: I18n.text('enrichmentProperties.panel.alerts.propertiesAccessError.title')
    });
  };
  const onSuccessDataTest = count => {
    const labels = {
      companyLabelLowercase,
      companyLabelPluralLowercase,
      contactLabelLowercase,
      contactLabelPluralLowercase
    };
    addAlertSuccess({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.modals.enrichRecords.alerts.success.description",
        options: {
          count,
          objectType: getObjectTypeLabel(objectTypeId, count, labels)
        }
      }),
      titleText: I18n.text('enrichmentProperties.modals.enrichRecords.alerts.success.title')
    });
  };
  const onSuccessProperties = count => {
    addAlertSuccess({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.panel.alerts.success.description",
        options: {
          count
        }
      }),
      titleText: I18n.text('enrichmentProperties.panel.alerts.success.title', {
        objectType: objectTypeLabelCapitalized
      })
    });
  };
  return {
    onError,
    onErrorPropertiesAccess,
    onSuccessDataTest,
    onSuccessProperties
  };
};